import React, { useState } from 'react';
import { firestore } from '../../firebase/config';
import { collection, query, where, orderBy, limit, getDocs } from 'firebase/firestore';

// Lista de Localidades (Padronizada)
const TODAS_LOCALIDADES = [
    '1 - ALAMAR', '2 - ALEGRIA', '3 - ALTO DA BOA VISTA', '4 - ANTARES', '5 - ARIVALDO REIS',
    '6 - ASSENTAMENTO SANTA MARIA', '7 - CAJUEIRO', '8 - CATARITO', '9 - CENTAURO', '10 - CENTRO',
    '11 - DISTRITO DA COLÔNIA', '12 - DINAH BORGES', '13 - DOUTOR GUSMÃO', '14 - EDGAR TRANCOSO',
    '15 - ENCANTO DAS ÁGUAS', '16 - FAZENDA SÃO JOSÉ', '17 - GABIARRA', '18 - ITAPUÃ',
    '19 - IVAN MOURA', '20 - JARDIM AMENDOEIRA', '21 - JARDINS DE EUNÁPOLIS', '22 - JUCA ROSA',
    '23 - MATINHA', '24 - MINAS GERAIS', '25 - MOISÉS REIS', '26 - MOTOR', '27 - MUNDO NOVO',
    '28 - NOVA EUNÁPOLIS', '29 - PARQUE COLONIAL', '30 - PARQUE DAS FRAMBOESAS', '31 - PARQUE NACIONAL',
    '32 - PARQUE RENOVAÇÃO', '33 - PEQUI', '34 - P. MARAVILHA', '35 - PONTO BAHIA',
    '36 - PONTO MANECA (COLÔNIA III)', '37 - PROJETO PRODUZIR', '38 - QUILOMETRO 52',
    '39 - RECANTO DAS ARVORES', '40 - RESIDENCIAL ALECRIM', '41 - RESIDENCIAL ARNALDO MOURA',
    '42 - RESIDENCIAL TALISMÃ', '43 - ROÇA DO POVO', '44 - ROSA NETO', '45 - SANTA ISABEL',
    '46 - SANTA LÚCIA', '47 - SANTA RITA', '48 - SAPUCAEIRA', '49 - STELA REIS',
    '50 - TIAGO DE MELO I (ALECRIM I)', '51 - TIAGO DE MELO II (ALECRIM II)', '52 - URBIS I',
    '53 - URBIS II', '54 - URBIS III', '55 - VERACELL', '56 - VISTA ALEGRE',
    '57 - VIVENDAS COSTA AZUL'
];

// Função para obter data de hoje no formato YYYY-MM-DD
const getTodayString = () => {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    const todayLocal = new Date(today.getTime() - (offset * 60 * 1000));
    return todayLocal.toISOString().split('T')[0];
};

// Função para normalizar texto
const normalizarTexto = (texto) => {
    if (!texto) return '';
    return String(texto).trim().toUpperCase();
};

function AuditoriaLog({ user }) {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);

    // Filtros
    const [startDate, setStartDate] = useState(getTodayString());
    const [endDate, setEndDate] = useState(getTodayString());
    const [filterResponsavel, setFilterResponsavel] = useState('');
    const [filterLocalidade, setFilterLocalidade] = useState('');

    // Função para calcular data máxima (30 dias)
    const getMaxDate = (start) => {
        if (!start) return '';
        const d = new Date(start);
        d.setDate(d.getDate() + 29); // 30 dias de intervalo
        return d.toISOString().split('T')[0];
    };

    const fetchLogs = async () => {
        if (!startDate || !endDate) {
            alert("Selecione o período de busca.");
            return;
        }

        // Validação de intervalo de 30 dias
        const diffTime = Math.abs((new Date(endDate)) - (new Date(startDate)));
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 29) {
            alert("O período máximo de busca é de 30 dias.");
            return;
        }

        setLoading(true);
        try {
            const [sYear, sMonth, sDay] = startDate.split('-');
            const start = new Date(sYear, sMonth - 1, sDay);
            start.setHours(0, 0, 0, 0);

            const [eYear, eMonth, eDay] = endDate.split('-');
            const end = new Date(eYear, eMonth - 1, eDay);
            end.setHours(23, 59, 59, 999);

            // Query com filtro de data
            const q = query(
                collection(firestore, 'auditoria_alteracoes'),
                where('dataAlteracao', '>=', start),
                where('dataAlteracao', '<=', end),
                orderBy('dataAlteracao', 'desc'),
                limit(200) // Aumentado para 200 registros
            );

            const snapshot = await getDocs(q);
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            console.log(`✅ Auditoria: ${data.length} registros encontrados no período`);
            setLogs(data);
        } catch (error) {
            console.error("Erro ao buscar logs:", error);
            alert("Erro ao buscar logs de auditoria.");
        }
        setLoading(false);
    };

    // Filtros aplicados no cliente
    const filteredLogs = logs.filter(log => {
        // Filtro de Responsável
        if (filterResponsavel) {
            const resp = log.responsavel?.identificador?.toLowerCase() || '';
            if (!resp.includes(filterResponsavel.toLowerCase())) return false;
        }

        // Filtro de Localidade
        if (filterLocalidade) {
            const localidade = log.contexto?.localidade || '';
            if (normalizarTexto(localidade) !== normalizarTexto(filterLocalidade)) return false;
        }

        return true;
    });

    return (
        <div style={{ padding: '20px' }}>
            <h2>📋 Auditoria de Alterações</h2>
            <p style={{ color: '#666' }}>Histórico das alterações realizadas em visitas.</p>

            <div className="filters-container" style={{ margin: '20px 0', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px' }}>
                {/* Filtro de Data Início */}
                <div className="input-group">
                    <label>Data Início</label>
                    <input
                        type="date"
                        value={startDate}
                        onChange={e => {
                            const newStart = e.target.value;
                            setStartDate(newStart);
                            // Auto-ajusta data final se necessário
                            if (newStart && endDate) {
                                const maxDate = getMaxDate(newStart);
                                if (endDate < newStart) {
                                    setEndDate(newStart);
                                } else if (endDate > maxDate) {
                                    setEndDate(maxDate);
                                }
                            }
                        }}
                    />
                </div>

                {/* Filtro de Data Fim */}
                <div className="input-group">
                    <label>Data Fim (Máx. 30 dias)</label>
                    <input
                        type="date"
                        value={endDate}
                        onChange={e => setEndDate(e.target.value)}
                        min={startDate}
                        max={getMaxDate(startDate)}
                    />
                </div>

                {/* Filtro de Responsável */}
                <div className="input-group">
                    <label>Responsável (Supervisor)</label>
                    <input
                        type="text"
                        placeholder="Nome do supervisor..."
                        value={filterResponsavel}
                        onChange={e => setFilterResponsavel(e.target.value)}
                    />
                </div>

                {/* Filtro de Localidade */}
                <div className="input-group">
                    <label>Localidade</label>
                    <select
                        value={filterLocalidade}
                        onChange={e => setFilterLocalidade(e.target.value)}
                    >
                        <option value="">Todas as localidades</option>
                        {TODAS_LOCALIDADES.map(loc => (
                            <option key={loc} value={loc}>{loc}</option>
                        ))}
                    </select>
                </div>

                {/* Botão de Buscar */}
                <div className="input-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <button
                        onClick={fetchLogs}
                        disabled={loading}
                        style={{
                            width: '100%',
                            padding: '10px 15px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            fontWeight: 'bold'
                        }}
                    >
                        {loading ? 'Buscando...' : 'Buscar'}
                    </button>
                </div>
            </div>

            {/* Contador de Resultados */}
            {!loading && logs.length > 0 && (
                <p style={{ marginTop: '10px', color: '#666' }}>
                    Exibindo <strong>{filteredLogs.length}</strong> de <strong>{logs.length}</strong> registros
                    {filteredLogs.length !== logs.length && ' (filtrados)'}
                </p>
            )}

            {loading ? <p>Carregando...</p> : (
                <div className="table-wrapper">
                    <table className="data-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9em' }}>
                        <thead>
                            <tr style={{ background: '#f4f4f4', textAlign: 'left' }}>
                                <th style={{ padding: '10px' }}>Data/Hora</th>
                                <th style={{ padding: '10px' }}>Responsável</th>
                                <th style={{ padding: '10px' }}>Visita Alterada</th>
                                <th style={{ padding: '10px' }}>Alterações (Campo: De &rarr; Para)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.length === 0 && !loading ? (
                                <tr><td colSpan="4" style={{ padding: '20px', textAlign: 'center' }}>Selecione o período e clique em "Buscar" para carregar os logs.</td></tr>
                            ) : filteredLogs.length === 0 && logs.length > 0 ? (
                                <tr><td colSpan="4" style={{ padding: '20px', textAlign: 'center' }}>Nenhum registro encontrado para os filtros aplicados.</td></tr>
                            ) : (
                                filteredLogs.map(log => (
                                    <tr key={log.id} style={{ borderBottom: '1px solid #ddd' }}>
                                        <td style={{ padding: '10px', verticalAlign: 'top' }}>
                                            {log.dataAlteracao?.toDate ? log.dataAlteracao.toDate().toLocaleString('pt-BR') : '—'}
                                        </td>
                                        <td style={{ padding: '10px', verticalAlign: 'top' }}>
                                            <strong>{log.responsavel?.identificador}</strong><br />
                                            <span style={{ fontSize: '0.8em', color: '#666' }}>{log.responsavel?.perfil}</span>
                                        </td>
                                        <td style={{ padding: '10px', verticalAlign: 'top' }}>
                                            {log.contexto ? (
                                                <div>
                                                    <strong style={{ color: '#007bff' }}>Visita #{log.contexto.idVisita}</strong><br />
                                                    <strong>{log.contexto.logradouro}, {log.contexto.numero}</strong><br />
                                                    <span style={{ fontSize: '0.8em', color: '#666' }}>{log.contexto.localidade}</span>
                                                </div>
                                            ) : (
                                                <small style={{ fontFamily: 'monospace' }}>ref: {log.visitaId.slice(0, 8)}...</small>
                                            )}
                                        </td>
                                        <td style={{ padding: '10px' }}>
                                            {log.detalhes?.map((detalhe, idx) => (
                                                <div key={idx} style={{ marginBottom: '5px' }}>
                                                    <strong>{detalhe.campo}:</strong>
                                                    <span style={{ color: '#d9534f', textDecoration: 'line-through', margin: '0 5px' }}>{detalhe.anterior}</span>
                                                    {'→'}
                                                    <span style={{ color: '#5cb85c', marginLeft: '5px' }}>{detalhe.novo}</span>
                                                </div>
                                            ))}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default AuditoriaLog;

